/** @jsx jsx */
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import React from 'react';

import { withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/diagram-emotional-distress-source.svg';
import { color, font } from 'src/shared/styles/variables';

const DescriptionHeading = styled('h3')(
    {
        color: color.blueLagoon,
    },
    font.heavy(font.size.large),
);

export interface Emotions {
    heading: string;
    content: string;
}

export const LearningAboutEmotionalDistressStep = withTranslation('cbt')(
    ({ t }: WithTranslation) => {
        const descriptions: Emotions[] = t(
            'week-1.learning-about-emotional-distress.descriptions',
            {
                returnObjects: true,
            },
        );

        return (
            <>
                <S.ContentRow>
                    <S.ContentColumn>
                        <S.StepHeading>
                            {t('week-1.learning-about-emotional-distress.title')}
                        </S.StepHeading>
                    </S.ContentColumn>
                </S.ContentRow>
                <S.ContentRow>
                    <S.ContentColumn md={14}>
                        {descriptions.map((content: Emotions) => (
                            <React.Fragment key={content.heading}>
                                <DescriptionHeading>{content.heading}</DescriptionHeading>
                                <S.StepDescription
                                    small
                                    css={{ '&:last-child': { marginTop: '3rem' } }}
                                >
                                    {content.content}
                                </S.StepDescription>
                            </React.Fragment>
                        ))}
                    </S.ContentColumn>
                    <S.ContentColumn md={10}>
                        <S.StepIcon iconUrl={stepIcon} />
                    </S.ContentColumn>
                </S.ContentRow>
            </>
        );
    },
);
